/* 130R — carrinho: gaveta lateral, página /cart, "Confirmar no WhatsApp" e barra de frete.
   PIX5 desligado em 20/10/2026 (sem total "no Pix" na tela nem na mensagem; docs/site/checkout-mercado-pago-2026-10-20.md).
   Agente carrinho, rodada 2 (18/10/2026). Marcação: snippets/cart-drawer.liquid (gaveta),
   sections/main-cart.liquid (página) e snippets/r130-carrinho-conteudo.liquid (conteúdo dos dois).

   ABRIR A GAVETA POR CÓDIGO (para a barra do celular, o header e outros scripts):
     - window.R130Carrinho.abrir()
     - document.dispatchEvent(new CustomEvent('open-cart-drawer'))   (o mesmo evento do ícone do header)
     - qualquer elemento com o atributo [data-r130-carrinho-abrir]    (o clique abre a gaveta)
   Na página /cart não há gaveta: os três levam ao título da página.
   CONTADOR: todo .js-cart-items-count e [data-r130-carrinho-qtd] recebe o número de itens, e o evento
   'r130:carrinho' (detail = carrinho do /cart.js) dispara a cada mudança.

   Como funciona: o script do tema (common.js) cria window.Cart; aqui o add() dele é trocado pelo nosso
   (abre a gaveta em vez do aviso "Produto adicionado com sucesso") e a gaveta antiga do tema é desligada. */
(function () {
  'use strict';
  if (window.R130Carrinho) return;

  var FONE = '5511910801297';
  var SECAO_GAVETA = 'r130-carrinho-gaveta';
  var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var URLS = { add: raiz + 'cart/add.js', change: raiz + 'cart/change.js', update: raiz + 'cart/update.js', cart: raiz + 'cart.js' };
  var reduzir = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var dlg = null;
  var estado = { cart: null, fila: Promise.resolve(), timers: {}, voltarFoco: null, fechando: null };

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function dinheiro(centavos) {
    try {
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(centavos / 100).replace(/ /g, ' ');
    } catch (e) { return 'R$ ' + (centavos / 100).toFixed(2).replace('.', ','); }
  }
  function pecas(n) { return n === 1 ? '1 peça' : n + ' peças'; }

  /* fetch que funciona com e sem o embrulho de window.fetch do tema (que lança o JSON quando dá erro). */
  function pedir(url, opcoes) {
    opcoes = opcoes || {};
    opcoes.credentials = 'same-origin';
    opcoes.headers = Object.assign({ 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, opcoes.headers || {});
    return fetch(url, opcoes).then(function (r) {
      if (r && typeof r.json === 'function') return r.json().then(function (j) { if (!r.ok) throw j; return j; });
      return r;
    });
  }
  function msgErro(e) {
    return (e && (e.description || e.message)) || 'Não foi possível atualizar o carrinho. Tente de novo.';
  }

  /* ---------- seções (o HTML do carrinho vem pronto do Liquid) ---------- */
  function raizes() { return $$('[data-r130-cart-raiz]'); }
  function idsSecoes() {
    var ids = [];
    raizes().forEach(function (r) { var id = r.getAttribute('data-secao'); if (id && ids.indexOf(id) < 0) ids.push(id); });
    return ids;
  }
  function comSecoes(obj) {
    var ids = idsSecoes();
    if (ids.length) { obj.sections = ids.join(','); obj.sections_url = location.pathname; }
    return obj;
  }

  function guardarEstadoForm(r) {
    var g = { foco: null, campos: {} };
    var ativo = document.activeElement;
    if (ativo && r.contains(ativo) && ativo.getAttribute('data-r130-foco')) {
      var linha = ativo.closest('[data-r130-cart-linha]');
      g.foco = { tipo: ativo.getAttribute('data-r130-foco'), key: linha ? linha.getAttribute('data-key') : null };
    }
    $$('[data-r130-preservar][id]', r).forEach(function (el) {
      g.campos[el.id] = { value: el.value, checked: el.checked, open: el.open };
    });
    return g;
  }
  function restaurarEstadoForm(r, g) {
    Object.keys(g.campos).forEach(function (id) {
      var el = document.getElementById(id), v = g.campos[id];
      if (!el || !r.contains(el)) return;
      if (el.tagName === 'DETAILS') el.open = v.open;
      else if (el.type === 'checkbox') el.checked = v.checked;
      else el.value = v.value;
    });
    if (!g.foco) return;
    var alvo = null;
    if (g.foco.key) {
      $$('[data-r130-cart-linha]', r).some(function (l) {
        if (l.getAttribute('data-key') !== g.foco.key) return false;
        alvo = $('[data-r130-foco="' + g.foco.tipo + '"]', l);
        return true;
      });
    } else {
      alvo = $('[data-r130-foco="' + g.foco.tipo + '"]', r);
    }
    if (!alvo || alvo.disabled) alvo = $('[data-r130-cart-titulo]');
    if (alvo) alvo.focus({ preventScroll: true });
  }

  function aplicarSecoes(secoes) {
    if (!secoes) return false;
    var ok = false;
    raizes().forEach(function (r) {
      var html = secoes[r.getAttribute('data-secao')];
      if (!html) return;
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var nova = $('[data-r130-cart-raiz]', tmp);
      if (!nova) return;
      var g = guardarEstadoForm(r);
      r.innerHTML = nova.innerHTML;
      restaurarEstadoForm(r, g);
      ok = true;
    });
    return ok;
  }
  function recarregarSecoes() {
    var ids = idsSecoes();
    if (!ids.length) return Promise.resolve();
    return pedir(location.pathname + '?sections=' + encodeURIComponent(ids.join(','))).then(aplicarSecoes).catch(function () {});
  }

  /* ---------- estado e contadores ---------- */
  function atualizarEstado(cart) {
    if (!cart || !cart.items) return cart;
    if (cart.sections) delete cart.sections;
    estado.cart = cart;
    var tema = window.Cart;
    if (tema && typeof tema === 'object') tema.value = cart;
    var n = cart.item_count;
    $$('.js-cart-items-count, [data-r130-carrinho-qtd]').forEach(function (el) { el.textContent = n; });
    $$('.js-cart-icon-container').forEach(function (el) { el.setAttribute('data-items', n); });
    $$('.js-cart-icon-total-money').forEach(function (el) { el.textContent = dinheiro(cart.total_price); el.setAttribute('data-money', cart.total_price); });
    document.dispatchEvent(new CustomEvent('r130:carrinho', { detail: cart }));
    return cart;
  }
  function buscarCarrinho() {
    return pedir(URLS.cart).then(atualizarEstado);
  }

  /* fila: uma mudança por vez, na ordem dos cliques */
  function enfileirar(fn) {
    var p = estado.fila.then(fn);
    estado.fila = p.catch(function () {});
    return p;
  }

  /* ---------- aviso para leitor de tela ---------- */
  function anunciar(msg) {
    var alvo = (dlg && dlg.open) ? $('[data-r130-cart-anuncio]', dlg) : $('[data-r130-cart-anuncio-fora]');
    if (!alvo) return;
    alvo.textContent = '';
    setTimeout(function () { alvo.textContent = msg; }, 60);
  }
  function mostrarErro(msg) {
    if (window.SendMessage && typeof window.SendMessage.open === 'function') window.SendMessage.open(msg);
    else window.alert(msg);
  }

  /* ---------- gaveta ---------- */
  function travar() {
    var html = document.documentElement;
    html.style.setProperty('--r130-cart-sb', Math.max(0, window.innerWidth - html.clientWidth) + 'px');
    html.classList.add('r130-cart-travado');
  }
  function destravar() {
    document.documentElement.classList.remove('r130-cart-travado');
    document.documentElement.style.removeProperty('--r130-cart-sb');
  }

  function marcarAdicionado(varianteId) {
    if (!dlg) return;
    var ok = $('[data-r130-cart-ok]', dlg);
    if (ok) ok.hidden = !varianteId;
    if (!varianteId) return;
    $$('[data-r130-cart-linha]', dlg).forEach(function (l) {
      if (String(l.getAttribute('data-variante')) === String(varianteId)) {
        l.classList.add('is-novo');
        try { l.scrollIntoView({ block: 'nearest' }); } catch (e) {}
      }
    });
  }

  /* foco preso: Tab no último volta ao primeiro e Shift+Tab no primeiro vai ao último (sem sair para o navegador) */
  function focaveis(r) {
    return $$('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), textarea:not([disabled]), select:not([disabled]), summary, [tabindex]', r).filter(function (el) {
      return el.getAttribute('tabindex') !== '-1' && el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden';
    });
  }
  function prenderFoco(ev) {
    if (ev.key !== 'Tab' || !dlg || !dlg.open) return;
    var f = focaveis(dlg);
    if (!f.length) return;
    var ativo = document.activeElement, primeiro = f[0], ultimo = f[f.length - 1];
    if (ev.shiftKey && (ativo === primeiro || f.indexOf(ativo) < 0)) { ev.preventDefault(); ultimo.focus(); }
    else if (!ev.shiftKey && (ativo === ultimo || f.indexOf(ativo) < 0)) { ev.preventDefault(); primeiro.focus(); }
  }

  function abrir(opcoes) {
    opcoes = opcoes || {};
    if (!dlg) {
      var tit = $('[data-r130-cart-titulo]');
      if (tit) { tit.scrollIntoView({ behavior: reduzir ? 'auto' : 'smooth', block: 'start' }); tit.focus({ preventScroll: true }); }
      return;
    }
    marcarAdicionado(opcoes.adicionado);
    if (dlg.open) {
      clearTimeout(estado.fechando);
      dlg.classList.add('is-open');
      var t = $('[data-r130-cart-titulo]', dlg);
      if (t) t.focus();
      return;
    }
    estado.voltarFoco = document.activeElement;
    travar();
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
    requestAnimationFrame(function () { requestAnimationFrame(function () { dlg.classList.add('is-open'); }); });
    var titulo = $('[data-r130-cart-titulo]', dlg);
    if (titulo) titulo.focus();
    document.dispatchEvent(new CustomEvent('r130:carrinho-aberto'));
  }
  function fechar() {
    if (!dlg || !dlg.open) return;
    dlg.classList.remove('is-open');
    var fim = function () {
      if (!dlg.open) return;
      if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open');
    };
    clearTimeout(estado.fechando);
    if (reduzir) fim(); else estado.fechando = setTimeout(fim, 230);
  }
  function aoFechar() {
    destravar();
    marcarAdicionado(null);
    $$('.is-novo', dlg).forEach(function (l) { l.classList.remove('is-novo'); });
    var v = estado.voltarFoco;
    estado.voltarFoco = null;
    if (v && document.contains(v) && typeof v.focus === 'function') { try { v.focus({ preventScroll: true }); } catch (e) {} }
  }

  /* ---------- adicionar (substitui o Cart.add do tema) ---------- */
  function adicionar(dados, extra) {
    extra = extra || {};
    var corpo;
    if (dados instanceof FormData) {
      corpo = dados;
      var ids = idsSecoes();
      if (ids.length) { corpo.append('sections', ids.join(',')); corpo.append('sections_url', location.pathname); }
    } else {
      corpo = JSON.stringify(comSecoes(dados));
    }
    var opcoes = { method: 'POST', body: corpo };
    if (!(dados instanceof FormData)) opcoes.headers = { 'Content-Type': 'application/json' };
    return enfileirar(function () {
      return pedir(URLS.add, opcoes).then(function (res) {
        var atualizou = aplicarSecoes(res.sections);
        var item = res.items ? res.items[0] : res;
        return (atualizou ? Promise.resolve() : recarregarSecoes()).then(buscarCarrinho).then(function (cart) {
          if (extra.desfazer) {
            anunciar('Peça devolvida ao carrinho. Agora são ' + pecas(cart.item_count) + '.');
            return item;
          }
          abrir({ adicionado: item && item.variant_id });
          anunciar('Peça adicionada ao carrinho. Agora são ' + pecas(cart.item_count) + ', total ' + dinheiro(cart.total_price) + '.');
          if (document.querySelector('.r130-cart-pagina') === null) {
            document.dispatchEvent(new CustomEvent('product-added', { detail: item }));
          }
          return item;
        });
      });
    }).catch(function (e) {
      mostrarErro(msgErro(e));
    });
  }

  /* ---------- quantidade e remover ---------- */
  function mudar(key, qtd, linha) {
    if (linha) linha.setAttribute('aria-busy', 'true');
    var nome = linha ? linha.getAttribute('data-nome') : '';
    var antes = linha ? parseInt(linha.getAttribute('data-qtd'), 10) : null;
    var variante = linha ? linha.getAttribute('data-variante') : null;
    return enfileirar(function () {
      return pedir(URLS.change, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(comSecoes({ id: key, quantity: qtd }))
      }).then(function (cart) {
        var secoes = cart.sections;
        if (dlg) marcarAdicionado(null);
        if (!aplicarSecoes(secoes)) recarregarSecoes();
        atualizarEstado(cart);
        if (qtd === 0) {
          anunciar((nome || 'Peça') + ' removida do carrinho. Agora são ' + pecas(cart.item_count) + '.');
          oferecerDesfazer(variante, antes, nome);
        } else {
          var item = null;
          cart.items.some(function (i) { if (i.key === key) { item = i; return true; } return false; });
          if (item && item.quantity < qtd) anunciar('Só temos ' + item.quantity + ' unidade(s) desta peça. Quantidade ajustada.');
          else anunciar('Quantidade alterada para ' + qtd + '. Total ' + dinheiro(cart.total_price) + '.');
        }
      });
    }).catch(function (e) {
      if (linha) linha.removeAttribute('aria-busy');
      anunciar(msgErro(e));
      mostrarErro(msgErro(e));
      recarregarSecoes().then(buscarCarrinho).catch(function () {});
    });
  }

  function oferecerDesfazer(variante, qtd, nome) {
    if (!variante || !qtd) return;
    raizes().forEach(function (r) {
      var lista = $('[data-r130-cart-corpo]', r) || $('.r130-cart', r);
      if (!lista) return;
      var div = document.createElement('div');
      div.className = 'r130-cart__desfazer';
      var p = document.createElement('p');
      p.textContent = 'Você removeu ' + (nome || 'uma peça') + '.';
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = 'Desfazer';
      b.setAttribute('data-r130-foco', 'desfazer');
      b.addEventListener('click', function () {
        b.disabled = true;
        adicionar({ items: [{ id: parseInt(variante, 10), quantity: qtd }] }, { desfazer: true });
      });
      div.appendChild(p);
      div.appendChild(b);
      lista.insertBefore(div, lista.firstChild);
    });
  }

  function linhaDe(el) { return el.closest('[data-r130-cart-linha]'); }
  function agendar(linha, qtd, atraso) {
    var key = linha.getAttribute('data-key');
    clearTimeout(estado.timers[key]);
    estado.timers[key] = setTimeout(function () {
      delete estado.timers[key];
      if (qtd === parseInt(linha.getAttribute('data-qtd'), 10)) return;
      mudar(key, qtd, linha);
    }, atraso);
  }
  function lerQtd(input) {
    var v = parseInt(input.value, 10);
    if (isNaN(v) || v < 0) v = 0;
    var max = parseInt(input.getAttribute('max'), 10);
    if (!isNaN(max) && v > max) v = max;
    return v;
  }

  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;

    var abrirEl = t.closest('[data-r130-carrinho-abrir]');
    if (abrirEl) { ev.preventDefault(); abrir(); return; }

    if (!t.closest('[data-r130-cart-raiz], [data-r130-carrinho]')) return;

    if (t.closest('[data-r130-cart-fechar]')) { ev.preventDefault(); fechar(); return; }

    var botao = t.closest('[data-r130-cart-mais], [data-r130-cart-menos]');
    if (botao) {
      ev.preventDefault();
      var linha = linhaDe(botao);
      var input = linha && $('[data-r130-cart-qtd]', linha);
      if (!input) return;
      var v = lerQtd(input) + (botao.hasAttribute('data-r130-cart-mais') ? 1 : -1);
      var max = parseInt(input.getAttribute('max'), 10);
      if (v < 0) v = 0;
      if (!isNaN(max) && v > max) { v = max; anunciar('Só temos ' + max + ' unidade(s) desta peça.'); }
      input.value = v;
      agendar(linha, v, v === 0 ? 0 : 450);
      return;
    }

    var rem = t.closest('[data-r130-cart-remover]');
    if (rem) {
      ev.preventDefault();
      var l = linhaDe(rem);
      if (l) { clearTimeout(estado.timers[l.getAttribute('data-key')]); mudar(l.getAttribute('data-key'), 0, l); }
    }
  });

  document.addEventListener('change', function (ev) {
    var input = ev.target;
    if (!input || !input.matches) return;
    if (input.matches('[data-r130-cart-qtd]')) {
      var linha = linhaDe(input);
      if (linha) { var v = lerQtd(input); input.value = v; agendar(linha, v, 0); }
    } else if (input.matches('[data-r130-cart-nota]')) {
      pedir(URLS.update, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: input.value }) }).catch(function () {});
    }
  });
  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Enter' && ev.target && ev.target.matches && ev.target.matches('[data-r130-cart-qtd]')) {
      ev.preventDefault();
      ev.target.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  /* ---------- WhatsApp: a mensagem é montada na hora do clique, com o carrinho atual ---------- */
  function mensagemWhats(cart) {
    var codigos = {};
    $$('[data-r130-cart-linha]').forEach(function (l) { codigos[l.getAttribute('data-key')] = l.getAttribute('data-codigo') || ''; });
    var linhas = cart.items.map(function (it) {
      var nome = it.product_title + (!it.product_has_only_default_variant && it.variant_title ? ' (' + it.variant_title + ')' : '');
      var s = it.quantity + 'x ' + nome;
      if (codigos[it.key]) s += ' - cód. ' + codigos[it.key];
      return s;
    });
    return 'Olá! Quero confirmar estas peças antes de finalizar a compra no site:\n\n' + linhas.join('\n') +
      '\n\nTotal: ' + dinheiro(cart.total_price) +
      '\n\nChassi:';
  }
  /* Na captura de window: roda antes do r130-chassi.js (captura no document), que depois põe o chassi
     salvo no "Chassi:" do fim. O link abre por clique normal (target=_blank), sem bloqueio de pop-up. */
  function aoClicarWhats(ev) {
    var a = ev.target && ev.target.closest ? ev.target.closest('[data-r130-cart-wa]') : null;
    if (!a || !estado.cart || !estado.cart.items || !estado.cart.items.length) return;
    a.href = 'https://wa.me/' + FONE + '?text=' + encodeURIComponent(mensagemWhats(estado.cart));
  }
  window.addEventListener('click', aoClicarWhats, true);
  window.addEventListener('auxclick', aoClicarWhats, true);
  /* Confere o /cart.js quando a pessoa encosta no botão (pega mudança feita em outra aba). */
  function preAquecer(ev) {
    var t = ev.target;
    if (t && t.closest && t.closest('[data-r130-cart-wa]')) buscarCarrinho().catch(function () {});
  }
  document.addEventListener('pointerdown', preAquecer, true);
  document.addEventListener('focusin', preAquecer, true);

  /* ---------- tema: troca o add() e desliga a gaveta e o aviso antigos ---------- */
  function adaptarTema(c) {
    if (!c || typeof c !== 'object' || c.__r130) return;
    c.__r130 = true;
    c.add = function (form) { return adicionar(new FormData(form)); };
    c.initEventDrawer = function () {};
    c.updateDrawer = function () {};
    c.initEventDropdown = function () {};
    c.updateLayout = function () { if (this.value) atualizarEstado(this.value); };
    c.notify = { show: function () { abrir(); }, close: function () {} };
  }
  (function () {
    var atual = window.Cart;
    if (atual) { adaptarTema(atual); return; }
    try {
      Object.defineProperty(window, 'Cart', {
        configurable: true,
        enumerable: true,
        get: function () { return atual; },
        set: function (v) { atual = v; adaptarTema(v); }
      });
    } catch (e) {
      document.addEventListener('DOMContentLoaded', function () { adaptarTema(window.Cart); });
    }
  })();

  /* ---------- início ---------- */
  function iniciar() {
    dlg = document.getElementById('r130-carrinho');
    if (dlg) {
      dlg.addEventListener('cancel', function (ev) { ev.preventDefault(); fechar(); });
      dlg.addEventListener('close', aoFechar);
      dlg.addEventListener('click', function (ev) { if (ev.target === dlg) fechar(); });
      dlg.addEventListener('keydown', prenderFoco);
    }
    document.addEventListener('open-cart-drawer', function () { abrir(); });
    window.addEventListener('pageshow', function (ev) { if (ev.persisted) recarregarSecoes().then(buscarCarrinho).catch(function () {}); });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState !== 'visible' || !estado.cart) return;
      var antes = estado.cart.item_count + ':' + estado.cart.total_price;
      buscarCarrinho().then(function (c) {
        if (c.item_count + ':' + c.total_price !== antes) recarregarSecoes();
      }).catch(function () {});
    });
    buscarCarrinho().catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();

  window.R130Carrinho = { abrir: abrir, fechar: fechar, adicionar: adicionar, atualizar: function () { return recarregarSecoes().then(buscarCarrinho); } };
})();
